import { useForm } from "react-hook-form";
export function useMoveInfoForm(options = {}) {
  return useForm(options);
}

export function usePropertyInfoForm(options = {}) {
  return useForm(options);
}

export function useStorageMoveInfoForm(options = {}) {
  return useForm(options);
}
